import { CHANGE_TAB } from './types';

const changeTab = (state, { activeTab }) => ({
  ...state,
  activeTab,
});

const reducer = {
  [CHANGE_TAB]: changeTab,
};

const initialState = {
  activeTab: 0,
};

export default (state = initialState, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
